import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { locationHistory } from "../../AxiosRtk/LocateFamily";
import moment from "moment";
import useCrypto from "../../../customHooks/crypto";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import LoadingIndicator from "../../../../setup/Loader/LoaderIndicator";
import {
  handleStartDateCommon,
} from "../../../../utils/helper";
import Select from "react-select";
import useDurationOption from "../../../customHooks/durationOption";
import useLangTranslation from "../../../customHooks/languageProvider";
import KidImage from "../../../shared/KidImage/KidImage";
import { kidDevices, setKidDevicesList } from "../../AxiosRtk/DashBoard";
import DateFilter from "../../../shared/DateFilter/DateFilter";

const intervalOptions = [
  { label: "Every 1 minute", value: 60 },
  { label: "Every 5 minutes", value: 300 },
  { label: "Every 15 minutes", value: 900 },
];

const LocationHistory = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { durationOptionsFunction } = useDurationOption();
  const { decryptRequest } = useCrypto();
  const [selectedDuration, setSelectedDuration] = useState(1);
  const durationOptions = durationOptionsFunction();
  const [kidListOptions, setkidListOptions] = useState([]);
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [loader, setLoader] = useState(false);
  const [selectedDeviceId, setSelectedDeviceId] = useState("");
  const [selectedChild, setSelectedChild] = useState(null);
  const [locationData, setLocationData] = useState([]);
  const initialEndDate = moment().locale("en").format("YYYY-MM-DD");
  const initialStartDate = moment().locale("en").format("YYYY-MM-DD");

  const [startDate, setStartDate] = useState(initialStartDate);
  const [endDate, setEndDate] = useState(initialEndDate);
  const [deviceData, setDeviceData] = useState(null);
  const [selectedInterval, setSelectedInterval] = useState(60); // Default: 1 minute (60 seconds)
  const { kidList, selectedKidId, kidDevicesList, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);
  const { user } = useSelector(({ auth }) => auth);
  const MAP_KEY = decryptRequest(process.env.REACT_APP_GOOGLE_MAP_KEY);
  const selectedKidData = kidList?.find((item) => item?.ID === selectedKidId);
  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );
  const { getLangTranslation } = useLangTranslation();

  useEffect(() => {
    if (selectedDeviceData) {
      // const deviceJson = selectedDeviceData
      //   ? JSON.parse(selectedDeviceData)
      //   : null;
      setSelectedChild(selectedKidData);
      setSelectedDeviceId(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  useEffect(() => {
    setkidListOptions(
      kidList?.map((item) => {
        return { value: item?.ID, label: item?.childName };
      })
    );
  }, [kidList]);

  useEffect(() => {
    if (kidDevicesList?.length > 0 && selectedDeviceId) {
      const kidDeviceData = kidDevicesList?.find(
        (item) => item?.ID === parseInt(selectedDeviceId?.ID)
      );
      setDeviceData(kidDeviceData);
    }
  }, [kidDevicesList, selectedDeviceId]);

  const handleChildChange = (id) => {
    const selectedChildData = kidList.find((child) => child.ID === id);
    setSelectedChild(selectedChildData);
  };

  function getKidDeviceList(selectedDeviceData) {
    dispatch(setKidDevicesList([]));
    if (selectedDeviceData) {
      kidDevices(selectedDeviceData?.ID)
        .then((res) => {
          dispatch(setKidDevicesList(res?.data?.result));
        })
        .catch((err) => {
          console.log(
            "getting kid device list catch error ==>>",
            err?.response?.data?.message
          );
        });
    }
  }

  useEffect(() => {
    getLocations();
    getKidDeviceList(selectedChild);
  }, [startDate, selectedDeviceId, selectedChild, selectedInterval, endDate]);

  function getLocations() {
    setLoader(true);
    if (selectedDeviceId) {
      const obj = {
        kidId: selectedKidId,
        deviceId: selectedDeviceId,
        interval: selectedInterval,
        startDate: startDate,
        endDate: endDate,
      };

      locationHistory(obj)
        .then((res) => {

          setLocationData(res?.data?.result);
          setLoader(false);
        })
        .catch((err) => {
          setLoader(false);
          console.log("rating catch error ==>>", err?.response?.data?.message);
        });
    }
  }

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: MAP_KEY,
    libraries: ["places"],
  });
  if (!isLoaded) {
    return "Loading";
  }
  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div className="d-inline-flex align-items-center lh-1">
                  <div
                    className="text-blue-900 pt-cursor fs-5"
                    onClick={() => history.goBack()}
                  >
                    <i
                      className={`${
                        lang?.isRTL === 1
                          ? "icon-arrow-right"
                          : "icon-arrow-left"
                      }`}
                    />
                  </div>
                  <h3 className="text-blue-900 mb-0">
                    {" "}
                    {getLangTranslation("LOCATION_HISTORY", "Location History")}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item content-300 w-100">
              <div className="select-with-icon" >
                <KidImage
                  imageUrl={selectedChild?.image}
                  gender={selectedChild?.gender}
                />
                <Select
                  className="custom-select"
                  classNamePrefix="custom-select"
                  placeholder="Select Device"
                  onChange={(val) => handleChildChange(val.value)}
                  options={kidListOptions}
                  value={
                    kidListOptions?.find(
                      (item) => item?.value == selectedChild?.ID
                    ) || ""
                  }
                />
              </div>
            </div>
            <div className="list-item col-12 col-md-3" >
              <div className="select-with-icon">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                <Select
                  className="custom-select custom-select-top"
                  classNamePrefix="custom-select"
                  placeholder="Select Device"
                  options={deviceOptions}
                  value={
                    deviceOptions?.find(
                      (item) => item?.value == selectedDeviceId
                    ) || ""
                  }
                  onChange={(val) => {
                    setSelectedDeviceId(val.value);
                  }}
                  isSearchable={false}
                  styles={
                    selectedChild
                      ? {
                          placeholder: (base) => ({
                            ...base,
                            marginBottom: '12px', // Adjust this value as needed
                          }),
                        }
                      : {}
                  }
                />
                {kidDevicesList?.length > 0 && deviceData?.LockDuration > 0 && (
                  <span className="text-small text-danger select-custom-text">
                    {getLangTranslation(
                      "CHILD_LOCATION_OFFLINE_DEVICE",
                      "Offline Device"
                    )}
                  </span>
                )}

                {kidDevicesList?.length > 0 && !deviceData?.LockDuration && (
                  <span className="text-small text-success select-custom-text">
                    {getLangTranslation(
                      "CHILD_LOCATION_ACTIVE_DEVICE",
                      "Active device"
                    )}
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          <div
            className="d-flex align-items-center flex-wrap gap-6 mb-6"
            style={{ justifyContent: "end" }}
          >
            <div className="content-200 w-100">
              <Select
                className="custom-select "
                classNamePrefix="custom-select"
                placeholder="Select Interval"
                options={intervalOptions}
                value={
                  intervalOptions?.find(
                    (item) => item?.value == selectedInterval
                  ) || ""
                }
                onChange={(val) => {
                  setSelectedInterval(val.value);
                }}
                isSearchable={false}
              />
            </div>
            <div className="content-200 w-100">
              <DateFilter
                startDate={startDate}
                endDate={endDate}
                setEndDate={setEndDate}
                setStartDate={setStartDate}
                selectedDuration={selectedDuration}
              />
              <Select
                className="custom-select"
                classNamePrefix="custom-select"
                placeholder="Select"
                onChange={(val) => {
                  handleStartDateCommon(
                    val,
                    setStartDate,
                    setSelectedDuration,
                    setEndDate
                  );
                }}
                options={durationOptions}
                value={
                  durationOptions?.find(
                    (item) => item?.value == selectedDuration
                  ) || ""
                }
              />
            </div>
          </div>
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className="v-middle" scope="col">
                    <div className="form-check">
                      <label
                        className="form-check-label mt-1"
                        htmlFor="taskName"
                      >
                        {getLangTranslation("PERMISSIONS_LOCATION", "Location")}
                      </label>
                    </div>
                  </th>
                  <th className="v-middle" scope="col">
                    {getLangTranslation("DATE", "date")}
                  </th>
                </tr>
              </thead>
              <tbody>
                {locationData?.length > 0 &&
                  locationData?.map((item) => (
                    <tr>
                      <td style={{ padding: 0 }} className="v-middle">
                        <div
                          style={{
                            display: "flex",
                            gap: "2rem",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              width: "12rem",
                              height: "5rem",
                              alignItems: "center",
                            }}
                            className="mb-6"
                          >
                            <GoogleMap
                              center={{
                                lat: Number(item?.latitude), // parent latitude
                                lng: Number(item?.longitude), // parent longitude
                              }}
                              zoom={15}
                              mapContainerStyle={{
                                width: "100%",
                                height: "100%",
                              }}
                              options={{
                                zoomControl: false,
                                streetViewControl: false,
                                mapTypeControl: false,
                                fullscreenControl: true,
                              }}
                            >
                              <Marker
                                position={{
                                  lat: Number(item?.latitude), // parent latitude
                                  lng: Number(item?.longitude), // parent longitude
                                }}
                              />
                            </GoogleMap>
                          </div>
                          <label className="form-check-label" htmlFor="one">
                            {item?.address}
                          </label>
                        </div>
                      </td>
                      <td
                        style={{ paddingTop: "33px" }}
                        className="v-middle text-nowrap"
                      >
                        {item?.locationTime}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {loader && (
              <div className="w-100 my-3">
                <LoadingIndicator height={20} width={100} color="#66B5FF" />
              </div>
            )}
            {!loader && locationData?.length === 0 && (
              <div className="w-100 my-3 text-center">
                {getLangTranslation("NO_DATA_LOG", "No data found")}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LocationHistory;
